export interface Option {
  [key: string]: string[] | string;
}

function stringCheck(value: unknown) {
  if(typeof value === "string") {
    return true;
  }

  return false;
}

export function validationErrorMessages(option?: Option): string[] {
  const errors = Object.values(option ?? {});

    return errors.reduce<string[]>((prev, current) => {
      if(current) {
        if (Array.isArray(current)) {
          const strings = current.filter(stringCheck)
            return [...prev, ...strings];
          }

        if(stringCheck(current)) {
          return [...prev, current];
        }
  

      }

      return prev;
    }, [] );

}